import { MilestoneDisplayModelFormGroup } from '@/api/model-index';
import { ConfirmationDialogAction, ConfirmationDialogResult } from '@/core/components/dialogs/confirmation-dialog/confirmation-dialog.component';
import { PortalContextService } from '@/core/services/portal-context.service';
import { Component } from '@angular/core';
import { Validators } from '@angular/forms';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { I18nService } from '../../../../services/i18nService';
import { FocusManagedDialogComponent } from '@/core/components/dialogs/focus-managed-dialog.component';
import { FocusService } from '@/core/services/focus.service';

@Component({
  selector: 'app-milestone-dialog',
  templateUrl: './milestone-dialog.component.html',
  styleUrls: ['./milestone-dialog.component.scss']
})
export class MilestoneDialogComponent extends FocusManagedDialogComponent {
  public milestoneFormGroup: MilestoneDisplayModelFormGroup;
  public milestoneIndex: number | null | undefined;
  public currentBerichtId: string | null | undefined;

  constructor(dialog: DialogRef, protected languageService: I18nService, protected portalContextService: PortalContextService, protected focusService: FocusService) {
    super(focusService,dialog);

    this.milestoneFormGroup = MilestoneDisplayModelFormGroup.Instance;

    this.milestoneFormGroup.clearValidators();
    this.milestoneFormGroup.Betreff.addValidators(Validators.required);
    this.milestoneFormGroup.DatumPlan.addValidators(Validators.required);
  }

  public get isSaveDisabled(): boolean {
    return this.milestoneFormGroup.valid == false;
  }

  public get dateFormat(): string{
    return this.languageService.GetCurrentShortDateFormat(true);
  }

  public get isUpdatedInProjektBericht(): boolean{
    if(this.milestoneIndex != null){
      return !((this.milestoneFormGroup.ErstelltInProjektBerichtId.value == null && this.currentBerichtId == null) || this.milestoneFormGroup.ErstelltInProjektBerichtId.value == this.currentBerichtId);
    }
    return false;
  }

  public onCancelClick() {
    this.closeDialog(null, ConfirmationDialogAction.Cancel);
  }

  public onSaveClick() {
    this.closeDialog(this.milestoneFormGroup, ConfirmationDialogAction.Confirm)
  }

  public closeDialog(milestone: MilestoneDisplayModelFormGroup | null, action: ConfirmationDialogAction) {
    let result: MilestoneDialogResult = new MilestoneDialogResult();

    result.milestone = milestone;
    result.action = action;

    this.dialog.close(result);
  }
}

export class MilestoneDialogResult extends ConfirmationDialogResult {
  public milestone: MilestoneDisplayModelFormGroup | null;
}